export default function SidebarLogo({ isCollapsed }) {
  return (
    <div className="sidebar-logo">
      <img
        src={isCollapsed ? "/sidemenulogo/iconlogo.png" : "/sidemenulogo/harmoniq.png"}
        alt="HarmonIQ"
        className={`logo-image${isCollapsed ? " logo-image--icon" : ""}`}
      />
    </div>
  );
}
